
//引入路由配置模块
import BigData from './modules/BigData'
import About from './modules/About'
import Trademark from './modules/Trademark'
import Patent from './modules/Patent'
import Copyright from './modules/Copyright'
import knowledge from './modules/knowledge'
import IndustryNews from './modules/IndustryNews'
export default [
    {
        path: '/',
        redirect: '/Index',
    },
    {
        name: 'Login',
        path: '/Login',
        component: () => import('@/pages/Login'),
        meta: { title: '登录' },
    },
    {
        name: 'Index',
        path: '/Index',
        component: () => import('@/pages/Index'),
        meta: { title: '首页' },
    },
    {
        name: 'About',
        path: '/About',
        redirect: { name: 'Company' }, // 重定向到指定名称的路由
        component: () => import('@/pages/About'),
        meta: { title: '关于我们' },
        children: [...About]
    },
    {
        name: 'Trademark',
        path: '/Trademark',
        redirect: { name: 'SearchDesign' }, // 重定向到指定名称的路由
        component: () => import('@/pages/Trademark'),
        meta: { title: '商标注册' },
        children: [...Trademark]
    },
    {
        name: 'Patent',
        path: '/Patent',
        redirect: { name: 'SearchWrite' }, // 重定向到指定名称的路由
        component: () => import('@/pages/Patent'),
        meta: { title: '专利申请' },
        children: [...Patent]
    },
    {
        name: 'Copyright',
        path: '/Copyright',
        redirect: { name: 'Registration' }, // 重定向到指定名称的路由
        component: () => import('@/pages/Copyright'),
        meta: { title: '版权登记' },
        children: [...Copyright]
    },
    {
        name: 'knowledge',
        path: '/knowledge',
        redirect: { name: 'InventionPatent' }, // 重定向到指定名称的路由
        component: () => import('@/pages/knowledge'),
        meta: { title: '知产维权' },
        children: [...knowledge]
    },
    {
        name: 'IndustryNews',
        path: '/IndustryNews',
        redirect: { name: 'AllNews' }, // 重定向到指定名称的路由
        component: () => import('@/pages/IndustryNews'),
        meta: { title: '动态资讯' },
        children: [...IndustryNews]
    },
    {
        name: 'Contact',
        path: '/Contact',
        component: () => import('@/pages/Contact'),
        meta: { title: '联系顾问' },
        props(route) {
            return {
                id: route.query.id,
        
            }
        },
    },
    {
        name: 'BigData',
        path: '/BigData',
        component: () => import('@/pages/BigData'),
        meta: { title: '大数据' },
        props(route) {
            return {
                id: route.query.id,
        
            }
        },
        children: [...BigData]
    }
]